export default __webpack_public_path__ + "01b0f0bd6d05fb5d2971aa535dcbd692.jpg";